module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-table', {
    attrs: {
      "data-api": this.api.program,
      "viewable": false,
      "keyField": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "编号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "programName",
      "label": "节目名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "programAddress",
      "label": "节目地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "playUrl",
      "label": "加速地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "节目图片",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.programImage) ? [_c('img', {
          attrs: {
            "height": "50",
            "src": scope.row.programImage
          }
        })] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "添加时间"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00c23240","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/program/List.vue
// module id = 1094
// module chunks = 2